/**
 * Central configuration for GenAI models and settings
 */

export const GENAI_CONFIG = {
  // Standard low-latency Live model. Do not use the extended-thinking variant.
  DEFAULT_MODEL: "gemini-3.8-live",
} as const;
